import React from 'react';
import styles from './Background.module.css';

export function Background() {
  return (
    <div className={styles.background} aria-hidden="true">
      <span className={styles.gradient} />
      <span className={`${styles.orb} ${styles.orb1}`} />
      <span className={`${styles.orb} ${styles.orb2}`} />
      <span className={`${styles.orb} ${styles.orb3}`} />
      <span className={`${styles.orb} ${styles.orb4}`} />
      <span className={styles.spotlight} />
      <span className={`${styles.stars} ${styles.starsFar}`} />
      <span className={`${styles.stars} ${styles.starsNear}`} />
      <span className={styles.grain} />
      <span className={styles.vignette} />
    </div>
  );
}
